<div class="MainContainer animated fadeIn" *ngIf="!this.parent.loading">
  <div class="MainTitleBar">
      <p class="SectionTitle" style="margin-top: 0%;">{{ 'UsersMenu.Title' | translate }}</p>

      <mat-form-field appearance="outline" class="example-form-field TitleBarSearchInput" style="margin-left: 0%;">
        <mat-label>{{ 'SearchUser' | translate }}</mat-label>
        <input matInput type="text" [(ngModel)]="this.searchTerm" (change)="GetUsersFiltered();" autocomplete="off">
        <button mat-button *ngIf="!this.searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="GetUsersFiltered();">
          <mat-icon style="font-size: 20px;color: #0082e6;">search</mat-icon>
        </button>
        <button mat-button *ngIf="this.searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="this.searchTerm=''; GetUsersFiltered();">
          <mat-icon style="font-size: 20px;color: #0082e6;">close</mat-icon>
        </button>
      </mat-form-field>
  </div>

  <div class="overlay" *ngIf="ShowB2BAgentDeallocation || ShowGrantAllURLsAccess || PartnerSelectContainer || AgentSelectContainer;"></div>

  <div class="PartnerSelectContainer animated fadeInDown" *ngIf="this.PartnerSelectContainer == true;">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="PartnerSelectContainer = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{'B2BConnectedPartner' | translate}}
    </div>
    <div class="InfoQuestionBody">
      <mat-form-field class="BrandSelectContainer" appearance="outline">
        <mat-label>{{'ChoosePartner' | translate}}*</mat-label>
        <input class="BrandSelect"
               type="text"
               placeholder="{{'ChoosePartner' | translate}}"
               matInput
               [matAutocomplete]="auto1"
               [(ngModel)]="this.Filter.SearchTerm"
               (ngModelChange)="this.partnerSearchTermUpdate.next($event)"
               >
        <i class="material-icons BrandSelectCloseIcon" *ngIf="this.B2BPartner?.Name?.length > 0;" (click)="ClearPartnerBrand();">close</i>
        <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.B2BPartner?.Name?.length > 0) != true;">search</i>
        <mat-autocomplete #auto1="matAutocomplete">
          <mat-option *ngFor="let p of Partners" [value]="p" (click)="this.B2BPartner = p; this.Filter.SearchTerm = p.Name;">
            {{p.Name}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div class="InfoQuestionCommands">
      <button mat-raised-button color="primary" class="ChoosePartnerButton" (click)="AddUpdateB2BUserPartnerConnection();">{{'ChoosePartner' | translate}}</button>
    </div>
  </div>

  <div class="PartnerSelectContainer animated fadeInDown" *ngIf="this.AgentSelectContainer == true;">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="AgentSelectContainer = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{'B2BConnectedAgent' | translate}}
    </div>
    <div class="InfoQuestionBody">
      <mat-form-field class="UserCompanyRolesSelect" appearance="outline" style="margin: 0;width: 100%;">
        <mat-label>{{ 'B2BConnectedAgent' | translate }}</mat-label>
        <mat-select name="Agent" [compareWith]="compareFn" [(ngModel)]="B2BAgent">
          <mat-option *ngFor="let agent of this.Agents" [value]="agent" (click)="SelectB2BAgent(agent);">
            {{agent.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="InfoQuestionCommands">
      <button mat-raised-button color="primary" class="ChoosePartnerButton" (click)="AddUpdateB2BUserAgentConnection();">{{'ChooseAgent' | translate}}</button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowGrantAllURLsAccess">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowGrantAllURLsAccess = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
     <span *ngIf="AppAccess?.Access == true;">{{'GrantAllURLsAccess' | translate}}</span>
     <span *ngIf="AppAccess?.Access != true;">{{'UnGrantAllURLsAccess' | translate}}</span>
    </div>
    <div class="InfoQuestionBody" style="padding-right: 5%;">
      <span *ngIf="AppAccess?.Access == true;">{{'GrantAllURLsAccessDescription' | translate}}</span>
      <span *ngIf="AppAccess?.Access != true;">{{'UnGrantAllURLsAccessDescription' | translate}}</span>
    </div>
  
    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" color="primary" mat-raised-button class="InfoQuestionButton" *ngIf="AppAccess?.Access == true;" (click)="GrantUserAppUrlsAccess(this.AppAccess);">
        {{ 'GrantAllURLsAccessButton' | translate }}
      </button>

      <button [disabled]="this.parent.loading" color="primary" mat-raised-button class="InfoQuestionButton" *ngIf="AppAccess?.Access != true;" (click)="GrantUserAppUrlsAccess(this.AppAccess);">
        {{ 'UnGrantAllURLsAccessButton' | translate }}
      </button>

      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowGrantAllURLsAccess = false;">
        {{ 'CancelButton' | translate }}
      </button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowB2BAgentDeallocation">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowB2BAgentDeallocation = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'Configuration.DeleteQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'Configuration.DeleteQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowB2BAgentDeallocation = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowB2BAgentDeallocation = false; DeallocateB2BUserAgentConnection();">{{ 'Configuration.DeleteYesButton' | translate }}</button>
    </div>
  </div>

  <div class="MainBody">

    <mat-accordion>

        <mat-expansion-panel disabled>
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ 'Login.User' | translate }}
              </mat-panel-title>
              <mat-panel-description>
                {{ 'Login.Email' | translate }}
              </mat-panel-description>
              <mat-panel-description>
                {{ 'AccountSettingsPage.Registered' | translate }}
              </mat-panel-description>
            </mat-expansion-panel-header>
          </mat-expansion-panel>

        <mat-expansion-panel *ngFor="let user of users" (opened)="GetUser(user)">
          <mat-expansion-panel-header class="ExpandHeadder">
            <mat-panel-title>
              {{user.UserName}}
            </mat-panel-title>
            <mat-panel-description>
              {{user.Email}}
            </mat-panel-description>
            <mat-panel-description>
                {{user.EventRegisterUI}}
              </mat-panel-description>
          </mat-expansion-panel-header>

          <div *ngIf="!loadingUser" style="margin-top: 2%;">

           <div class="PopUpBodySemiTextBox">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'AccountSettingsPage.MainRole' | translate }}</mat-label>
              <mat-select name="role" [compareWith]="compareFn" [(ngModel)]="user.Rights.MainRole">
                <mat-option *ngFor="let role of this.parent.masterData.Roles" [value]="role" (click)="user.Rights.MainRole = role;UpdateUserRights(user);">
                  {{role.Meaning}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="PopUpBodySemiTextBox">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'AccountSettingsPage.PageAccess' | translate }}</mat-label>
              <mat-select multiple [(ngModel)]="user.Rights.URLs" [compareWith]="compareMultipleFn">
                <mat-option class="URLOption" *ngFor="let url of URLs" [value]="url" (onSelectionChange)="changeUrlAccess($event);" (click)="checkOption($event); UpdateUserURLAccess(url, user.Id);">
                  <p style="margin-top:20px;">{{url.Application?.Name}}</p>
                  <p>{{url.Path}}</p>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="PopUpBodySemiTextBox">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'AppAccess' | translate }}</mat-label>
              <mat-select multiple [(ngModel)]="AppAccessApplications" [compareWith]="compareMultipleFnAppAccess">
                <mat-option style="padding-bottom: 0px;" class="URLOption" *ngFor="let app of this.parent.Applications" [value]="app" (onSelectionChange)="changeAppAccess($event);" (click)="AddUpdateUserAppAccess(app);">
                  <p>{{app.Name}}</p>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          </div>

          <p>{{ 'AccountSettingsPage.UserID' | translate }}: {{user.Id}}</p>
          <p>{{ 'AccountSettingsPage.SecretToken' | translate }} {{user.Token}}</p>
          <p>{{ 'AccountSettingsPage.Registered' | translate }} {{user.EventRegisterUI}}</p>

          <div class="B2BRow" *ngIf="this.UserHasB2BAccess == true;">
            <span>{{'B2BConnectedPartner' | translate }}:</span>
            <button mat-raised-button color="primary" class="B2BRowButton" (click)="OpenPartnerSelectContainer();" *ngIf="B2BPartner == null;">
              <i class="material-icons">account_circle</i>
              {{'ChoosePartner' | translate}}
            </button>
            <button mat-raised-button color="primary" class="B2BRowButton" (click)="OpenPartnerSelectContainer();" *ngIf="B2BPartner?.ID?.length > 0;">
              <i class="material-icons">account_circle</i>
              {{B2BPartner?.Name}}
            </button>
          </div>

          <div class="B2BRow" *ngIf="this.UserHasB2BAccess == true;">
            <span>{{'B2BConnectedAgent' | translate }}:</span>
            <button mat-raised-button color="primary" class="B2BRowButton" (click)="OpenAgentSelectContainer();" *ngIf="B2BAgent == null;">
              <i class="material-icons">account_circle</i>
              {{'ChooseAgent' | translate}}
            </button>
            <button mat-raised-button color="primary" class="B2BRowButton" (click)="OpenAgentSelectContainer();" *ngIf="B2BAgent?.Name?.length > 0;">
              <i class="material-icons">account_circle</i>
              {{B2BAgent?.Name}}
            </button>

            <i class="material-icons B2BAgentEliminationIcon" *ngIf="B2BAgent?.Name?.length > 0;" (click)="PrepareB2BAgentDeallocation();">close</i>
          </div>

          <div class="APISection">
            <mat-slide-toggle (click)="AddUpdatePartnerB2BSettings(B2BPartner.B2BSettings.CanDownloadPriceLists);" *ngIf="B2BPartner?.ID?.length > 0;" class="DisabledUserToggle" [(ngModel)]="B2BPartner.B2BSettings.CanDownloadPriceLists">{{'CanDownloadPriceLists' | translate}}</mat-slide-toggle>
          </div>
          <mat-slide-toggle class="DisabledUserToggle" [(ngModel)]="user.Disabled" (click)="EnableDisableUser(user.Id, !user.Disabled);">{{'DisabledUser' | translate}}</mat-slide-toggle>

          <div class="APISection" *ngIf="user.B2BSettings != null;">
            <mat-slide-toggle class="DisabledUserToggle" [(ngModel)]="user.B2BSettings.B2BSearchPriceAPIAccess" (click)="user.B2BSettings.B2BSearchPriceAPIAccess = !user.B2BSettings.B2BSearchPriceAPIAccess; UpdateB2BSearchPriceAPIAccess(user, user.B2BSettings.B2BSearchPriceAPIAccess);">{{'HasB2BSearchPriceAPIAccess' | translate}}</mat-slide-toggle>
          </div>

          <p class="UserErrorRow unSelectable" *ngFor="let error of this.user.Rights.AccessErrors">
            <i class="material-icons">warning_amber</i>
            {{error}}
          </p>

          <mat-action-row>

            <div *ngIf="!loadingUser" style="width: 100%;">
              <div class="AssignedCompanies" *ngFor="let c of user.Rights.AssignedCompanies; let index = index">
                <mat-card class="example-card" style="min-height: 250px;">
                  <mat-card-header>
                    <mat-card-title>{{c.Name}}</mat-card-title>
                    <mat-card-subtitle>{{c.VATNumber}}</mat-card-subtitle>
                    <mat-card-subtitle>{{c.COCRegisterNr}}</mat-card-subtitle>
                    <mat-card-subtitle *ngIf="c.RequestedAccess != null;">{{ 'AccountSettingsPage.AccessRequestedOn' | translate }} {{c.RequestedAccess.EventUI}}</mat-card-subtitle>
                    <mat-card-subtitle>
                      <div class="RequestedCompanyAddress" *ngIf="c.MainRole.ID > 0;">
                        <i class="fa fa-check-circle"></i>
                      </div>
                    </mat-card-subtitle>
                  </mat-card-header>
                  <mat-card-actions>

                    <mat-form-field class="UserCompanyRolesSelect" appearance="outline">
                      <mat-label>{{ 'AccessLevelOnThisCompany' | translate }}</mat-label>
                      <mat-select name="role" [compareWith]="compareFn" [(ngModel)]="c.MainRole">
                        <mat-option *ngFor="let role of this.parent.masterData.Roles" [value]="role" (click)="ChangingCompanyID = c.ID; c.MainRole = role; UpdateUserRights(user);">
                          {{role.Meaning}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="UserCompanyRolesSelect" appearance="outline">
                      <mat-label>{{ 'FunctionInsideCompany' | translate }}</mat-label>
                      <mat-select name="Department" [compareWith]="compareFn" [(ngModel)]="c.Department">
                        <mat-option *ngFor="let f of this.parent.masterData.Departments" [value]="f" (click)="ChangingCompanyID = c.ID; c.Department = f; UpdateUserRights(user);">
                          {{f.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                  </mat-card-actions>
                </mat-card>
              </div>
            </div>
              
              <div class="fullWidthContainer" *ngIf="loadingUser">
                <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
              </div>

          </mat-action-row>

        </mat-expansion-panel>
      </mat-accordion>

  </div>
  </div>
